export const GatewayEventConstants = {
  CONNECTION: 'CONNECTION',
  DISCONNECTION: 'DISCONNECTION',
  IN_APP_NOTIFICATION: 'IN_APP_NOTIFICATION',
  MARK_ALL_IN_APP_NOTIFICATIONS_READ_STATUS:
    'MARK_ALL_IN_APP_NOTIFICATIONS_READ_STATUS'
}
